module.exports = __webpack_public_path__ + "973fdd592687ee23fbfe4f797e98200d.png";